const getSubdomain = ():string => {
  // If VITE_WINC_APP is set, use "winc" as the subdomain
  if (import.meta.env.VITE_WINC_APP) {
    return 'winc';
  }

  // Otherwise use explicit VITE_SUBDOMAIN or fall back to hostname
  const subdomain = window.location.hostname.split('.')[0];
  return import.meta.env.VITE_SUBDOMAIN ?? subdomain;
}

export { getSubdomain };